import { render, staticRenderFns } from "./EmailPasswordReset.vue?vue&type=template&id=515b7332&scoped=true"
import script from "./EmailPasswordReset.vue?vue&type=script&lang=js"
export * from "./EmailPasswordReset.vue?vue&type=script&lang=js"
import style0 from "./EmailPasswordReset.vue?vue&type=style&index=0&id=515b7332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515b7332",
  null
  
)

export default component.exports